import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider, RequireAuth } from 'react-auth-kit';
import AuthPage from './pages/AuthPage';
import LoginPage from './pages/LoginPage';
import MainPage from './pages/MainPage';
import ChatPage from './pages/ChatPage';
import SharePage from './pages/SharePage';
import NotFoundPage from './pages/NotFoundPage';
import { ThinkingProvider } from './contexts/thinking';
import { StatusProvider } from './contexts/status';
import Notifications from './components/notifications';
import Status from './components/status';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import SelectWineryModal from './components/selectWineryModal';
import { UserProvider } from './contexts/user';
import { ChatProvider } from './contexts/chat';
import LoginAsUserPage from './pages/LoginAsUserPage';
import { FeatureFlagsProvider } from './contexts/featureFlags';

const App = () => {
    return (
        <div id='App'>
            <ThemeProvider theme={theme}>
                <StatusProvider>
                    <ThinkingProvider>
                        <AuthProvider
                            authType='cookie'
                            authName='auth'
                            cookieDomain={window.location.hostname}
                            cookieSecure={false}
                        >
                            <FeatureFlagsProvider>
                                <UserProvider>
                                    <ChatProvider>
                                        <Notifications />
                                        <Status />
                                        <Router>
                                            <SelectWineryModal />
                                            <Routes>
                                                <Route
                                                    path='/'
                                                    element={
                                                        <RequireAuth loginPath='/auth'>
                                                            <MainPage />
                                                        </RequireAuth>
                                                    }
                                                />
                                                <Route
                                                    path='/c/:id'
                                                    element={
                                                        <RequireAuth loginPath='/auth'>
                                                            <ChatPage />
                                                        </RequireAuth>
                                                    }
                                                />
                                                <Route path='/share/:id' element={<SharePage />} />
                                                <Route path='/auth' element={<AuthPage />} />
                                                <Route path='/auth/login' element={<LoginPage />} />
                                                <Route path='/auth/login-as' element={<LoginAsUserPage />} />
                                                <Route path='*' element={<NotFoundPage />} />
                                            </Routes>
                                        </Router>
                                    </ChatProvider>
                                </UserProvider>
                            </FeatureFlagsProvider>
                        </AuthProvider>
                    </ThinkingProvider>
                </StatusProvider>
            </ThemeProvider>
        </div>
    );
};

export default App;
